import { FortStatusMdl } from './proposalResMdl';
export class FortCheckReqMdl
{
  public access_code: string;
  public  merchant_reference: string;
  public  language: string;
  public  merchant_identifier: string;
  public  signature: string;
  public query_command: string;
}


export class TransStatusMdl
{
  public  ApplicationNo: string;
  public Name: string;
  public TransDate: string;
  public Amt: string;
  public PaymentStatus: string;
  public  TransactionId: string;
  public  PolicyFileName: string;
  public st: FortStatusMdl=new FortStatusMdl();
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/FortCheckReqMdl.ts